var map = {
	"./NassKiosk.png": "640c",
	"./NassPOS.png": "e869",
	"./NassWinGame.png": "7900",
	"./WebPOS.png": "9863",
	"./locationrequest.png": "dca3",
	"./userrequest.png": "5ced"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5714";